import { create } from 'zustand';
import { AddUserSchemaT } from '../types/schema/userScheme';

type UserRequestStore = {
  currentUser: AddUserSchemaT | null;
  setCurrentUser: (user: AddUserSchemaT | null) => void;
  clearCurrentUser: () => void;
};

const useUserRequestStore = create<UserRequestStore>(set => ({
  currentUser: null,
  setCurrentUser: user => set({ currentUser: user }),
  clearCurrentUser: () => set({ currentUser: null }),
}));

export default useUserRequestStore;
